import therapyCalm from "../images/therapy-calm.jpg";

export default function About() {
  return (
    <section
      id="sobre-mi"
      className="py-20 bg-gradient-to-r from-white to-sky-50"
    >
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-10 items-center">
        {/* Imagen terapéutica */}
        <div className="flex justify-center md:justify-end">
          <div
            style={{
              backgroundImage: `url(${therapyCalm})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
            className="w-[90%] h-[300px] md:h-[400px] rounded-2xl shadow-lg"
            aria-label="Imagen terapéutica"
          />
        </div>

        {/* Texto de la sección */}
        <div className="text-center md:text-left">
          <h2 className="text-3xl font-semibold text-gray-900 mb-4">
            Sobre el lugar de Santa María.
          </h2>
          <p className="text-gray-700 leading-relaxed max-w-md mx-auto md:mx-0">
            Santa María de los Molles se considera un lugar de paz y mucha tranquilidad durante el año,
            donde es la combinación perfecta entre el campo y la playa, ubicado en una zona privilegiada por su vista al mar,
            su aroma de aire que purifica el cuerpo y espíritu y permite descansar plácidamente.
          </p>
        </div>
      </div>
    </section>
  );
}
